import {
	IPlatformAuthorizer,
	IPlatformContext,
	IPlatformUi,
	IPlatformRouter,
} from '@studyportals/bodies-editor-integration';
import { PlatformAuthorizerDecoratorUiLoader } from '@/infrastructure/ui-loader/PlatformAuthorizerDecoratorUiLoader';

export class PlatformIntegration {
	public static readonly instance = new PlatformIntegration();

	private _context: IPlatformContext | undefined;
	private _router: IPlatformRouter | undefined;
	private _authorizer: IPlatformAuthorizer | undefined;
	private _ui: IPlatformUi | undefined;

	private constructor() {
		// Restricit instantiation access
	}

	public set context(context: IPlatformContext | undefined) {
		this._context = context;
	}

	public get context(): IPlatformContext {
		if (this._context === undefined) {
			throw new Error('The platfrom context has not been set');
		}

		return this._context;
	}

	public set router(router: IPlatformRouter | undefined) {
		this._router = router;
	}

	public get router(): IPlatformRouter {
		if (this._router === undefined) {
			throw new Error('The platfrom router has not been set');
		}

		return this._router;
	}

	public set authorizer(authorizer: IPlatformAuthorizer | undefined) {
		this._authorizer = authorizer;
	}

	public get authorizer(): IPlatformAuthorizer {
		if (this._authorizer === undefined) {
			throw new Error('The platfrom authorizer has not been set');
		}

		return new PlatformAuthorizerDecoratorUiLoader(this._authorizer);
	}

	public set ui(ui: IPlatformUi | undefined) {
		this._ui = ui;
	}

	public get ui(): IPlatformUi {
		if (this._ui === undefined) {
			throw new Error('The platfrom UI has not been set');
		}

		return this._ui;
	}
}
